import { render, staticRenderFns } from "./SettingLabel.vue?vue&type=template&id=3024059b&scoped=true"
var script = {}
import style0 from "./SettingLabel.vue?vue&type=style&index=0&id=3024059b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3024059b",
  null
  
)

export default component.exports